import type { FunctionComponent } from 'react';
import { useEffect } from 'react';

import { useCoreDispatch } from '../../store/CoreStore';
import { performanceActions } from '../../store/slices/performance/slice';

import { PerformanceController } from './PerformanceController';

export const PerformanceControllerConnector: FunctionComponent = () => {
  const dispatch = useCoreDispatch();

  useEffect(() => {
    PerformanceController.setDegradationCallback(() => {
      dispatch(performanceActions.degrade());
    });
  }, [dispatch]);

  return null;
};
